import React, { useMemo, useState, useCallback } from 'react'
import AsyncSelect from 'react-select/async';
import { useOktaAuth } from '@okta/okta-react';
import debounce from 'debounce-async';

const isOptionSelected = (option, values) => {
    return values.some(({ value }) => option.value === value);
};

export const SelectGoldenRecord = ({ loadOptionsFunction, onChange }) => {
    const { authState } = useOktaAuth();
    const [showOptions, setShowOptions] = useState(false);

    const loadOptions = useMemo(() => {
        return debounce(async (inputValue) => {
            let options = undefined
            const stGoldenRecordList = await loadOptionsFunction(inputValue, authState.accessToken.accessToken);
            options = stGoldenRecordList.data.map((stGoldenRecord) => ({
                value: stGoldenRecord.id,
                label: `${stGoldenRecord.subtierSupplierNo} - ${stGoldenRecord.supplierName}`
            }))
            return options
        }, 300);
    }, [authState.accessToken.accessToken, loadOptionsFunction])

    const handleInputChange = useCallback((typedOption) => {
        (typedOption.length > 1) ? setShowOptions(true) : setShowOptions(false);
    }, []);

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? 'black' : 'black'
        }),
        control: base => ({
            ...base,
            height: 35,
            minHeight: 35,
            width: 'auto'
        }),
        menu: base=> ({
            ...base,
            position:'relative'
        }),
        dropdownIndicator: base => ({
            ...base,
            height: 35,
            minHeight: 35,
        }),
        placeholder: base => ({
            ...base,
        }),
        valueContainer: base => ({
            ...base,
            height: 35,
            minHeight: 35,
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;

            return { ...provided, opacity };
        }
    }

    return (
        <AsyncSelect
            cacheOptions={true}
            defaultOptions
            loadOptions={showOptions ? loadOptions : null}
            isOptionSelected={isOptionSelected}
            onInputChange={handleInputChange}
            isClearable={true}
            styles={customStyles}
            noOptionsMessage={() => 'Please enter 3 or more characters to search'}
            onChange={onChange}
        />
    )
}